export function operacaoTransferenciasInRequest(params = {}) {
  return {
    type: '@operacaotransferencia/OPERACAOTRANSFERENCIAS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoTransferencia(id) {
  return {
    type: '@operacaotransferencia/FIND_OPERACAOTRANSFERENCIA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaotransferencia/FAILED_REQUEST',
  };
}

export function deleteOperacaoTransferencia(id, params) {
  return {
    type: '@operacaotransferencia/DELETE_OPERACAOTRANSFERENCIA',
    payload: { id, params },
  };
}

export function updateOperacaoTransferencia(operacaotransferencia, params) {
  return {
    type: '@operacaotransferencia/UPDATE_OPERACAOTRANSFERENCIA',
    payload: { operacaotransferencia, params },
  };
}

export function storeOperacaoTransferencia(operacaotransferencia, params) {
  return {
    type: '@operacaotransferencia/STORE_OPERACAOTRANSFERENCIA',
    payload: { operacaotransferencia, params },
  };
}

export function successInRequest(
  operacaotransferencias,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaotransferencia/SUCCESS_IN_REQUEST',
    payload: {
      operacaotransferencias,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaotransferencia) {
  return {
    type: '@operacaotransferencia/SUCCESS_REQUEST',
    payload: { operacaotransferencia },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaotransferencia/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaotransferencia/RECORD_FILTERING',
    payload: { params },
  };
}
